<template>
    <div>
        <CompassSkeleton class="fake-general-information-title" size="x-large" />
        <div class="fake-general-information-block">
            <div>
                <CompassSkeleton class="fake-label" />
                <CompassSkeleton class="fake-date" />
                <CompassSkeleton class="fake-owner" />
                <CompassSkeleton class="fake-description" />
            </div>
            <div>
                <CompassSkeleton variant="square" size="small" />
                <CompassSkeleton class="fake-date-data" />
                <CompassSkeleton class="fake-owner-data" />
                <div v-for="(_, index) in 2" :key="index">
                    <CompassSkeleton variant="square" />
                    <CompassSkeleton class="fake-description-data" />
                </div>
            </div>
        </div>
        <CompassSkeleton class="fake-related-title" size="x-large" />
        <CompassSkeleton class="fake-related-block" variant="block" />
    </div>
</template>

<style lang="scss" scoped>
.fake-general-information {
    &-title {
        margin-bottom: var(--spacing-3);
        width: 314px;
    }

    &-block {
        column-gap: var(--spacing-4);
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: var(--spacing-5);

        & > div {
            display: flex;
            flex-direction: column;
            gap: var(--spacing-3);

            & > div {
                align-items: center;
                display: flex;
                flex-direction: row;
                gap: var(--spacing-1);
            }
        }

        .fake {
            &-label {
                width: 113px;
            }

            &-date {
                width: 44px;

                &-data {
                    width: 125px;
                }
            }

            &-owner {
                width: 83px;

                &-data {
                    width: 236px;
                }
            }

            &-description {
                width: 125px;

                &-data {
                    width: 125px;
                }
            }
        }
    }
}

.fake-related {
    &-title {
        margin-bottom: var(--spacing-3);
        width: 200px;
    }

    &-block {
        width: 416px;
    }
}
</style>
